import { PageContent } from "./PageContent";
import { PageContainer } from "./PageContainer";
import { PageHeader } from "./PageHeader";

const Page = {
  Container: PageContainer,
  Header: PageHeader,
  Content: PageContent,
};

export { Page };
